import {
  IClient,
  IClientEditProps,
  IClientRegisterProps,
} from "interfaces/Client";
import {
  IFilterData,
  IGetFilterProps,
  IGetUniqueData,
} from "interfaces/FilterProps";
import { client } from "./api";

export async function getClientsService({
  order,
  relations,
  skip,
  take,
  where,
}: IGetFilterProps<IClient>): Promise<IFilterData<IClient>> {
  const api = client();
  const response = await api.get<IFilterData<IClient>>("clients", {
    params: {
      take,
      skip,
      relations: JSON.stringify(relations),
      order: JSON.stringify(order),
      where: JSON.stringify(where),
    },
  });
  if (!response) {
    throw new Error();
  }
  return response.data;
}

export async function getClientService(
  id: string
): Promise<IGetUniqueData<IClient>> {
  const api = client();
  const response = await api.get<IGetUniqueData<IClient>>(`clients/one`, {
    params: {
      where: { id },
      relations: { product: { services: true } }
    },
  });
  return response.data;
}

export async function searchClientsService(
  query: string
): Promise<IFilterData<IClient>> {
  const api = client();
  const response = await api.get<IFilterData<IClient>>(
    `clients?filter=${query}`
  );
  return response.data;
}

export async function createClientsService({
  userName,
  password,
  rg,
  cpf,
  name,
  productName,
  cnpj,
  tradingName,
  managerName,
  email,
  details,
  type,
  regions,
  servicesIds,
  minimumBilling,
  productRegions,
}: IClientRegisterProps) {
  const api = client();
  const response = await api.post("clients", {
    client: {
      email,
      name,
      tradingName,
      managerName,
      cnpj,
      minimumBilling,
    },
    product: {
      name: productName,
      details,
      type,
      regions,
      productRegions,
    },
    servicesIds,
  });
  return response.data;
}

export async function editClientsService({
  clientData,
  regions,
  servicesIds,
  product,
  productRegions,
}: IClientEditProps) {
  const api = client();
  const response = await api.patch("clients", {
    client: clientData,
    servicesIds,
    product: { ...product, regions, productRegions },
  });

  return response.data;
}

export async function activeClient(id: string) {
  const api = client();
  const response = await api.post(`clients/${id}`);
  return response.data;
}

export async function deleteClient(id: string) {
  const api = client();
  const response = await api.delete(`clients/${id}`);
  return response.data;
}
